import { CANONICAL_ORIGIN, absoluteUrl } from './shared'

const PUBLISHER = {
  '@type': 'Organization',
  name: 'Riparide',
  logo: { '@type': 'ImageObject', url: 'https://assets.riparide.com/logo.png' },
}

interface FeaturedListing {
  url?: string
  title?: string
  promo_image?: { large?: string; medium?: string }
}

// The redux `story.data` shape (snake_case, from story_serializer.rb).
export interface DetailStory {
  title?: string
  url?: string
  created_at?: string
  updated_at?: string
  promo_image?: { large?: string; medium?: string }
  user?: { first_name?: string; fullname?: string; url?: string }
  featured_listing?: { listing?: FeaturedListing }
}

// A reference to the featured stay (no offers); @id is its canonical URL so it
// resolves to the same entity as the listing page's Product.
const aboutListing = (listing: FeaturedListing | undefined, origin: string) => {
  const url = listing && absoluteUrl(listing.url, origin)
  if (!url) return undefined

  return {
    '@type': 'LodgingBusiness',
    '@id': url,
    name: listing?.title,
    url,
    image: listing?.promo_image?.large || listing?.promo_image?.medium,
  }
}

// The story detail page as a schema.org Article, linked to its featured stay.
export const storyArticleJsonLd = (
  story: DetailStory | null | undefined,
  { origin = CANONICAL_ORIGIN }: { origin?: string } = {},
) => {
  if (!story) return null

  const url = absoluteUrl(story.url, origin)

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: story.title,
    image: story.promo_image?.large || story.promo_image?.medium,
    url,
    mainEntityOfPage: url,
    datePublished: story.created_at,
    dateModified: story.updated_at,
    author: story.user
      ? {
          '@type': 'Person',
          name: story.user.fullname || story.user.first_name,
          url: absoluteUrl(story.user.url, origin),
        }
      : undefined,
    publisher: PUBLISHER,
    about: aboutListing(story.featured_listing?.listing, origin),
  }
}
